<template>
    <v-list nav dense>
        <template>
            <v-list-item
                    v-if="(bandQr === true || bandCam === true) && getProfile.booth_registration === true && getProfile.idHousingUnit === 'bc7c051d-56eb-4dbf-b627-eca69ece6541'"
                    link
                    router to="/checkin_checkout_qr/0"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-developer-board</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('devices')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    v-if="(bandQr === true || bandCam === true) && getProfile.booth_registration === true && getProfile.idHousingUnit !== 'bc7c051d-56eb-4dbf-b627-eca69ece6541'"
                    link
                    router to="/checkin_checkout_qr2/0"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-developer-board</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('devices')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                link
                router
                to="/guard/club-events"
                class="list"
                active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-calendar-star</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('ce_gate_title') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
                    link
                    router to="/checkin_checkout"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-swap-horizontal</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('entradas_salidas')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/access_without_code"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-exit-to-app</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('acceso_sin_codigo')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/historical"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-book-open-page-variant</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('Historial')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                v-show="getProfile.enable_parcel === true"
                    link
                    router to="/parcel"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-truck</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('parcel')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    v-if="getProfile.show_current_invitations === true"
                    router to="/current_invitations"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-calendar-multiselect</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('current_invitations')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/settings"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('configuracion')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/financial_statements"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-finance</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('financial_statements')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/notices"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-bullhorn</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('Notices')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    v-show="getProfile.enable_reports === true"
                    link
                    router to="/reports"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-alert</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('Reports')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/ayuda"
                    class="list"
                    active-class="white black--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-help-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('Ayuda')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from '../../store/actions/auth'

export default {
  name: 'guard',
  computed: {
    ...mapState(['bandQr', 'bandCam']),
    ...mapGetters(['getProfile'])
  },
  created () {
    // console.log('permisos = ', JSON.parse(localStorage.getItem('permisos')))
    if (this.getProfile.role === 4 && this.getProfile.idHousingUnit === '898109fd-bb69-4d2f-a223-5457810e2171') {
      console.log('Hola Vigilante')
    } else
    if (this.getProfile.role === 4 && JSON.parse(localStorage.getItem('permisos')) !== true) {
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_color', 'error')
      this.$store.commit('snackbar_change_message', this.$t('msg_vigilant_sin_permisos'))
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'))
      setTimeout(this.clear, 5000)
    }
  },
  methods: {
    clear: function () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>
    .list:hover {
        background: white;
        opacity: 0.85;
    }
</style>
